import { inject, Service } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NavigationService } from '@core/providers/navigation/navigation.service';
import { AuthService } from './auth.service';

@Service()
export class AuthGuard {
  private navigationService = inject(NavigationService);
  private authService = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.authenticated()) {
      this.authService.setUserLanguage();

      return true;
    }

    if (this.authService.hasExpiredSession()) {
      this.authService.clearExpiredSession();
    }

    this.navigationService.goToLogin(state.url);

    return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }
}
